import { gql } from '@apollo/client';

export default gql`
  {
    Genres {
        IdGenero
        Genero
    }
  }
`;